module.exports = __webpack_public_path__ + "static/media/IC222amg.8dc9c33e.jpg";